//----------------------------------------------------
// Project js file
//----------------------------------------------------

// bootstrap import
// import "bootstrap"
import Loader from './parts/Loader.js'
import navigation from './parts/navigation.js'
import Smooth from './parts/Smooth.js'
import FirstView from './parts/FirstView.js'
import HorizontalLoop from './parts/HorizontalLoop.js'
import Accordion from './parts/Accordion.js'
import FaidSlide from './parts/FaidSlide.js'
import VideoShift from './parts/VideoShift.js'
import MouseStalker from './parts/MouseStalker.js'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

import { gsap } from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollSmoother)
navigation()

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
const smooth = new Smooth({
  linkTarget: '.nav_link a[href*="#"]',
  breakPoint: 768, // px
  pcWaitTime: 500, // ms
  spWaitTime: 500, // ms
  exceptionId: ['manabino', 'kanou', 'soijouka', 'shinbyu', 'chiesho'], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
    if (faidSlider) faidSlider.scrollAnimation(id)
  }
})

// ----------------------------------------------------
// ローダー
// ----------------------------------------------------
const loader = new Loader({
  endFn: () => {
    const hash = location.hash
    // console.log('endFn', hash)
    if (hash) {
      const id = hash.replace('#', '')
      if (faidSlider) faidSlider.scrollAnimation(id)
    }
  }
})

// ----------------------------------------------------
// スムーススクロール
// ----------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    let smoothFlag = false
    let scroller
    function createSmooth() {
      scroller = ScrollSmoother.create({
        smooth: 1.5, // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true, // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0.1 // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
      })
      smoothFlag = true
    }
    function killSmooth() {
      scroller.kill()
      scroller = null
    }
    if (window.innerWidth >= 768) {
      createSmooth()
    }
    window.addEventListener('resize', () => {
      if (
        !smoothFlag &&
        window.innerWidth >= 768 &&
        location.pathname !== '/'
      ) {
        // createSmooth()
        location.reload()
      } else if (
        smoothFlag &&
        window.innerWidth < 768 &&
        location.pathname !== '/'
      ) {
        // killSmooth()
        location.reload()
      }
    })
  }, 250)
})

// ----------------------------------------------------
// mainvisual animation [HorizontalLoop]
// ----------------------------------------------------
const wrapper = document.querySelector('.mainVisual_wrraper')
let loop
if (wrapper) {
  // const boxes = gsap.utils.toArray('.mainVisual_list')
  const headPcOuter = document.querySelector('.mainVisual_head-fixed-block.pc')
  const headSpOuter = document.querySelector('.mainVisual_head-fixed-block.sp')
  const headsPc = gsap.utils.toArray(
    '.mainVisual_list-content-inner-outer',
    headPcOuter
  )
  const headsSp = gsap.utils.toArray(
    '.mainVisual_list-content-inner-outer',
    headSpOuter
  )
  const counter = gsap.utils.toArray('.loop_current-num')
  const loopNextBtn = gsap.utils.toArray('.loop_next-btn')
  const loopPrevBtn = gsap.utils.toArray('.loop_prev-btn')

  let activeElement
  let activeHeadPc, activeHeadSp
  loop = new HorizontalLoop('#mainVisual_wrraper-outer', {
    snap: 0.1,
    onChange: (element, index) => {
      // when the active element changes, this function gets called.
      activeElement && activeElement.classList.remove('active')
      activeHeadPc && activeHeadPc.classList.remove('active')
      activeHeadSp && activeHeadSp.classList.remove('active')

      element.classList.add('active')
      headsPc[index].classList.add('active')
      headsSp[index].classList.add('active')

      activeElement = element
      activeHeadPc = headsPc[index]
      activeHeadSp = headsSp[index]

      counter.forEach((elm) => {
        elm.textContent = `${('00' + (index + 1)).slice(-2)}`
      })
    }
  })

  loop.changeIndex(-2)

  loopNextBtn.forEach((elm) => {
    elm.addEventListener('click', () => loop.next())
  })
  loopPrevBtn.forEach((elm) => {
    elm.addEventListener('click', () => loop.previous())
  })
}

// ----------------------------------------------------
// mainvisual animation [firstview]
// ----------------------------------------------------
const getHostnameFromString = function (path) {
  const result = path.replace(/\\/g, '/').match(/\/\/([^/]*)/)
  return result ? result[1] : ''
}
const firstViewContainer = document.getElementById('firstView_wrapper')
const ref = getHostnameFromString(document.referrer)
const domain = location.host
let firstView
if (firstViewContainer) {
  window.addEventListener('load', () => {
    if (ref !== domain) {
      // ファーストビューの動画をPCとSPで出し分ける
      // ----------------------------------------------------
      const videoElm = document.querySelector('.firstView_video')
      const vf = new VideoShift({
        changeFn: () => {
          // firstView.resetVideoElm()
        },
        videoElm: videoElm,
        videoClass: 'firstView_video',
        landscapeVideoSrc:
          'https://takao-yakuho.jp/wp-content/themes/thema/assets/first_view_pc.mp4',
        portraitVideoSrc:
          'https://takao-yakuho.jp/wp-content/themes/thema/assets/first_view_sp.mp4'
      })
      setTimeout(() => {
        firstView = new FirstView({
          container: firstViewContainer,
          videoClass: 'firstView_video',
          skipBtnClass: 'firstView_nav_arrow',
          onChange: (container) => {
            loop.changeIndex(0, 2500)
            gsap
              .to(container, {
                opacity: 0,
                pointerEvents: 'none',
                duration: 1.5,
                delay: 0.25,
                ease: 'power1.easeOut'
              })
              .then(() => {
                console.log('end first view')
              })
          }
        })
      }, 250)
    } else {
      gsap.to(firstViewContainer, {
        opacity: 0,
        pointerEvents: 'none',
        duration: 0
      })
      loop.changeIndex(0, 0)
    }
  })
}

// ----------------------------------------------------
// accordion animation
// ----------------------------------------------------

// header
const navAccordionList = gsap.utils.toArray('.sp_nav-li-ac')
if (navAccordionList.length) {
  const navAcordion = new Accordion(navAccordionList, {
    // toggleBtnClass: ,
    // itemClass: ,
    firstDisplay: false,
    onlyDisplay: false,
    onChange: (elm, value, i) => {
      const btn = gsap.utils.toArray('.sp_nav-acBtn', elm)
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add('active')
        })
      } else {
        btn.forEach((elm) => {
          elm.classList.remove('active')
        })
      }
    }
  })
}

// pharmacy
const pharmacyAccordionList = gsap.utils.toArray('.pageStores_list-ac-block')
const imgBg = gsap.utils.toArray('.pageStores_list-img')
if (pharmacyAccordionList.length) {
  const navAcordion = new Accordion(pharmacyAccordionList, {
    // toggleBtnClass: ,
    // itemClass: ,
    firstDisplay: false,
    onlyDisplay: true,
    onChange: (elm, value, i) => {
      const btn = gsap.utils.toArray('.pageStores_list-toggle-btn', elm)
      imgBg.forEach((elm) => {
        elm.classList.remove('active')
      })
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add('active')
        })
        imgBg[i].classList.add('active')
      } else {
        btn.forEach((elm) => {
          elm.classList.remove('active')
        })
        imgBg[i].classList.remove('active')
      }
    }
  })
}

// event
const eventAccordionList = gsap.utils.toArray('.pageEventList_content-list')
const eventImg = gsap.utils.toArray('.pageEventList_img-list')
if (eventAccordionList.length) {
  const eventAcordion = new Accordion(eventAccordionList, {
    // toggleBtnClass: ,
    // itemClass: ,
    firstDisplay: true,
    onlyDisplay: true,
    onChange: (elm, value, i) => {
      const btn = gsap.utils.toArray('.pageEventList_content-icon', elm)
      eventImg.forEach((elm) => {
        elm.classList.remove('active')
      })
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add('active')
        })
        eventImg[i].classList.add('active')
      } else {
        btn.forEach((elm) => {
          elm.classList.remove('active')
          eventImg[i].classList.add('active')
        })
      }
    }
  })
}
// new business
const newBizAccordionList = gsap.utils.toArray('.pageNewBizPost_content-list')
const newBizImg = gsap.utils.toArray('.pageNewBizPost_img-list')
if (newBizAccordionList.length) {
  const eventAcordion = new Accordion(newBizAccordionList, {
    // toggleBtnClass: ,
    // itemClass: ,
    firstDisplay: true,
    onlyDisplay: true,
    onChange: (elm, value, i) => {
      const btn = gsap.utils.toArray('.pageNewBizPost_content-icon', elm)
      newBizImg.forEach((elm) => {
        elm.classList.remove('active')
      })
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add('active')
        })
        newBizImg[i].classList.add('active')
      } else {
        btn.forEach((elm) => {
          elm.classList.remove('active')
          newBizImg[i].classList.add('active')
        })
      }
    }
  })
}

// footer
const footerNavAccordionList = gsap.utils.toArray('.spFooter_nav-li-ac')
if (footerNavAccordionList.length) {
  const navAcordion = new Accordion(footerNavAccordionList, {
    // toggleBtnClass: ,
    // itemClass: ,
    firstDisplay: false,
    onlyDisplay: false,
    onChange: (elm, value, i) => {
      const btn = gsap.utils.toArray('.spFooter_nav-icon.ac_mark', elm)
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add('active')
        })
      } else {
        btn.forEach((elm) => {
          elm.classList.remove('active')
        })
      }
    }
  })
}

// ----------------------------------------------------
// scroll animation
// ----------------------------------------------------
const faidSlideContainer = document.querySelector(
  '#pageStores_wrapper-container'
)
let faidSlider
document.addEventListener('DOMContentLoaded', () => {
  if (faidSlideContainer) {
    faidSlider = new FaidSlide(faidSlideContainer, {
      navigation: true,
      endFn: () => {},
      targetId: ['manabino', 'kanou', 'soijouka', 'shinbyu', 'chiesho']
    })
  }
})

// ----------------------------------------------------
// sub visual scroll animation
// ----------------------------------------------------
const subVisualScrollBtn = document.querySelector('.subVisual_underNav')
if (subVisualScrollBtn) {
  subVisualScrollBtn.addEventListener('click', () => {
    const height = window.innerHeight
    window.scrollTo({
      top: height,
      left: 0,
      behavior: 'smooth'
    })
  })
}

// ----------------------------------------------------
// event slider animation (sp)
// ----------------------------------------------------
const option = {
  spaceBetween: '12.5%',
  speed: 1000,
  longSwipesRatio: 0.15
}

const swiper = new Swiper('.pageEventList_sp-container', option)
const swiperNewBiz = new Swiper('.pageNewBizPost_sp-container', option)

// ----------------------------------------------------
// event slider animation (sp)
// ----------------------------------------------------
const flipBlock = document.querySelector('.pageGreet_img-outer')
if (flipBlock) {
  flipBlock.addEventListener('click', () => {
    flipBlock.classList.toggle('active')
  })
}

// ----------------------------------------------------
// マウスストーカー
// ----------------------------------------------------
const mouseStalker = new MouseStalker({
  stalkerClassName: 'mouse_stalker',
  hoverClass: 'mouse_stalker-link',
  scrub: 0.07
})
